<template>
  <ModalDialog
    ref="dialog"
    title="Order Items"
    icon="fa-shopping-cart"
    :showFooter="false"
    :scrollable="true"
  >
    <div>
      <Spinner v-if="loading" />
      <div class="text-center text-danger" v-if="loadingError">{{loadingError}}</div>

      <OrderItemList
        ref="orderItemList"
        v-if="order && orderItemData"
        v-model="orderItemData"
        :editing="false"
        :orderType="order.type"
        :showTotals="false"
        :showPricing="false"
        :showUnits="false"
      />
      

    </div>
  </ModalDialog>
</template>

<script>
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import orderItemMixin from '@/modules/orders/mixins/orderItemMixin'
import OrderItemList from '@/modules/orders/components/orderItemList'

export default {
  name: 'OrderItemsPreviewDialog',
  mixins: [
    modalDialog,
    orderItemMixin
  ],
  components: {
    ModalDialog,
    OrderItemList
  },
  props: {
    orderId: Number,
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      order: null,
      orderItemData: null
    }
  },  
  mounted() {
  },
  methods: {
    show(params) {
      this.requestData()

      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },

    requestData() {
      this.loading = true
      this.loadingError = ''

      this.$apiService.ordersService.getOrder(this.orderId)
      .then(response => {
        this.order = response.data

        // Copy the order item list & modify for display/editing
        this.orderItemData = this.buildOrderItemList(this.order.orderItems)
      })
      .catch(err => {
        this.loadingError = 'Error loading order'
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>